export const environment = {
  production: true,
  apiUrl: 'https://planard.api.test.smartmaplesoftware.com/api', //'http://pltestapi.mapleyazilim.com/api',
  hshPwd: 'e10adc3949ba59abbe56e057f20f883e',
  hshPwd1: '5232523ab4dce3a8cb6191ead18068f3',
  authority: 'https://planard.identity.test.smartmaplesoftware.com/', //'http://tstacc.mapleyazilim.com/',
  callback: 'https://planard.test.smartmaplesoftware.com/' //'http://test.planard.com/'
};
